import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GroupchatComponent } from '../groupchat.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'groupchat-button',
  templateUrl: './groupchat-button.component.html',
  styleUrls: ['./groupchat-button.component.scss'],
})
export class GroupchatButtonComponent implements OnInit {
  @Input() autoOpen = false;
  @Input() label = 'Chat';
  @Input() big = false;
  @Input() session: Session;
  @Input() idea: Idea;
  @Input() general = false;

  private ref: any;

  constructor(
    public modalService: NgbModal,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (this.autoOpen) {
      setTimeout(() => {
        this.route.queryParams.subscribe(params => {
          if (params.discussion) {
            this.openModal();
          }
        });
      }, 1000);
    }
  }

  openModal() {
    this.ref = this.modalService.open(GroupchatComponent);
    this.ref.componentInstance.session = this.session;
    this.ref.componentInstance.idea = this.idea;
    this.ref.componentInstance.general = this.general;
  }
}
